<!-- Card View -->
<div class="main-box clearfix profile-box-stats" *ngIf="!isUserRowViewActive">
    <div class="main-box-body clearfix">
        <div class="profile-box-notification emerald-bg">
            <div [id]="userInfo.userId + '-activity-dropdown'"
                class="dropdown pull-right candidate-job-card-notification-icon btn-group">
                <a class="btn dropdown-toggle p-3"
                    data-toggle="dropdown"
                    [id]="'activity-list-' + userInfo.userId"
                    aria-haspopup="true"
                    aria-expanded="false"
                    title="Activity Monitor"
                    (click)="showRecentActivities()">
                    <i class="fa fa-list"></i>
                </a>
                <ul [id]="userInfo.userId + '-activity-dropdown-menu'"
                    class="dropdown-menu candidate-job-match-activity-list"
                    role="menu">
                    <app-recent-activities
                        *ngIf="showRecentActivitiesFlag"
                        [activityMap]="activityMap"
                        [recentActivitiesControls]="recentActivitiesControls"
                        [isActivityClicked]="isActivityClicked"
                        context="userCard"
                        [userId]="userInfo.userId"
                        (activitiesLoadedCallback)="cardMenuToggled(true, userInfo.userId + '-activity-dropdown-menu')"
                        (showAllCallback)="showAllActivityModal()">
                    </app-recent-activities>
                </ul>
            </div>
        </div>

        <div class="profile-box-header emerald-bg pt-0 clearfix">
            <h2 *ngIf="userInfo.lastName !== null">
                <span class="pointer" (click)="viewProfile(userInfo, 'view')">
                    <span *ngIf="(userInfo.firstName + ' ' + userInfo.lastName).length > 17"
                        [title]="userInfo.firstName + ' ' + userInfo.lastName">
                        {{(userInfo.firstName + ' ' + userInfo.lastName) | slice:0:14}}...
                    </span>
                    <span *ngIf="!((userInfo.firstName + ' ' + userInfo.lastName).length > 17)">
                        {{userInfo.firstName + ' ' + userInfo.lastName}}
                    </span>
                </span>
                <span *ngIf="userInfo.userState === 'UnVerfied' || userInfo.userState === 'PasswordReset'"
                    style="font-weight: normal; font-size: 0.7em;">(UnVerified)</span>
                <sup *ngIf="userInfo.forwardRecipient">
                    <span class="pointer"
                        [title]="userInfo.forwardFromId !== (authService.getUserDetails() ? authService.getUserDetails().id : null) ? 'Forwarded to ' + userInfo.forwardFromUser : 'Forwarded to me'"
                        style="font-size: 20px;">
                        <i class="fa fa-share" aria-hidden="true"></i>
                    </span>
                </sup>
                <sup *ngIf="userInfo.forwardToId !== null">
                    <span class="pointer"
                        [title]="userInfo.forwardToId !== (authService.getUserDetails() ? authService.getUserDetails().id : null) ? 'Forwarded to ' + userInfo.forwardToUser : 'Forwarded to me'"
                        style="font-size: 20px;">
                        <i class="fa fa-share" aria-hidden="true"></i>
                    </span>
                </sup>
            </h2>

            <h2 *ngIf="userInfo.lastName === null">
                <span class="pointer" (click)="viewProfile(userInfo, 'view')">
                    <span *ngIf="userInfo.firstName.length > 17" [title]="userInfo.firstName">
                        {{userInfo.firstName | slice:0:14}}...
                    </span>
                    <span *ngIf="!(userInfo.firstName.length > 17)">{{userInfo.firstName}}</span>
                </span>
                <span *ngIf="userInfo.userState === 'UnVerfied' || userInfo.userState === 'PasswordReset'"
                    style="font-weight: normal; font-size: 0.7em;">(UnVerified)</span>
                <sup *ngIf="userInfo.forwardRecipient">
                    <span class="pointer"
                        [title]="userInfo.forwardFromId !== (authService.getUserDetails() ? authService.getUserDetails().id : null) ? 'Forwarded to ' + userInfo.forwardFromUser : 'Forwarded to me'"
                        style="font-size: 20px;">
                        <i class="fa fa-share" aria-hidden="true"></i>
                    </span>
                </sup>
                <sup *ngIf="userInfo.forwardToId !== null">
                    <span class="pointer"
                        [title]="userInfo.forwardToId !== (authService.getUserDetails() ? authService.getUserDetails().id : null) ? 'Forwarded to ' + userInfo.forwardToUser : 'Forwarded to me'"
                        style="font-size: 20px;">
                        <i class="fa fa-share" aria-hidden="true"></i>
                    </span>
                </sup>
            </h2>
            <br>
            <div class="job-position" style="display: inline-block;">{{userInfo.roleDescription}}</div>
            <span class="pointer" *ngIf="userInfo.canDrillDown" (click)="viewReportees(userInfo)">
                ({{userInfo.reporteesCount}} Direct Reports)
            </span>
            <img src="assets/app-content/img/samples/4dot5-default-no-profile-pic.jpg" alt=""
                class="profile-img img-responsive" />
        </div>

        <div class="profile-box-footer clearfix">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-offset-5 col-md-4"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- footer -->
    <div class="profile-box-footer clearfix" style="margin-top: -65px;">
        <a>
            <span *ngIf="userInfo.isLoadingCounts" class="skeleton-heading skeleton-loading d-inline-block mx-auto mb-1" style="width:20px;"></span>
            <span *ngIf="!userInfo.isLoadingCounts" class="candidatesvalue">{{userInfo.activeCandidatesCount}}</span>
            <span class="label">Active</span>
        </a>
        <a>
            <span *ngIf="userInfo.isLoadingCounts" class="skeleton-heading skeleton-loading d-inline-block mx-auto mb-1" style="width:20px;"></span>
            <span *ngIf="!userInfo.isLoadingCounts" class="candidatesvalue">{{userInfo.passiveCandidatesCount}}</span>
            <span class="label">Passive</span>
        </a>
        <a *ngIf="userInfo.canEdit || userInfo.canDelete" class="tmactions">
            <span class="value">
                <div class="btn-group" style="margin-top: 8px;">
                    <button type="button" class="btn btn-primary" data-toggle="dropdown">Actions</button>
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" role="menu">
                        <li class="dropdown-option action" *ngIf="userInfo.canEdit"
                            (click)="viewProfile(userInfo, 'edit')">
                            Edit
                        </li>
                        <li class="divider" *ngIf="userInfo.canDelete"></li>
                        <li class="dropdown-option action" *ngIf="userInfo.canDelete"
                            (click)="deleteSelectedUser(userInfo)">
                            Delete
                        </li>
                        <li class="divider" *ngIf="userInfo.canViewNotificationPref"></li>
                        <li class="dropdown-option action" *ngIf="userInfo.canViewNotificationPref"
                            (click)="$state.go('missioncontrol.notificationpreference', {userId: userInfo.userId}, {reload: true})">
                            Notification Preferences
                        </li>
                        <li class="divider" *ngIf="userInfo.userState !== 'Active'"></li>
                        <li class="dropdown-option action"
                            *ngIf="userInfo.userState === 'UnVerfied' || userInfo.userState === 'PasswordReset'"
                            (click)="resendInvite(userInfo)" style="padding-bottom: 6px">
                            Resend Invite
                        </li>
                        <li class="divider" *ngIf="notCurrentUser"></li>
                        <li class="dropdown-option action" *ngIf="notCurrentUser"
                            (click)="makeEmployee(userInfo)"
                            [ngClass]="{'disable-element': companyState === 'SoftHold'}">
                            Make Employee
                        </li>
                    </ul>
                </div>
            </span>
        </a>
    </div>
</div>

<!-- Row View -->
<div class="position-relative" *ngIf="isUserRowViewActive">
    <div class="px-0 border user-row-view-card width-transition"
        [ngClass]="{'col-xs-12': showUserScope, 'col-xs-6': !showUserScope}"
        style="border-radius: 5px;">
        <div class="px-0">
            <div class="col-xs-12 pr-0 pl-3 d-flex">
                <!-- Name & Image Column -->
                <div class="d-flex" [ngClass]="{'col-xs-6 py-4': !showUserScope, 'col-xs-3 pt-4 pb-3': showUserScope}">
                    <a *ngIf="userInfo.users && userInfo.users.length > 0"
                        class="pr-2 pt-2 mt-2 position-relative" style="color: gray; top: -1px"
                        (click)="toggleExpansion(userInfo)">
                        <span class="glyphicon pr-2" style="font-size: 14px"
                            [ngClass]="{'fas fa-chevron-right': userInfo.collapsed, 'fas fa-chevron-down': !userInfo.collapsed}">
                        </span>
                    </a>
                    <img src="assets/app-content/img/samples/4dot5-default-no-profile-pic.jpg" alt=""
                        class="user-row-view-card-image img-responsive mr-3 mt-2">
                    <div class="d-flex flex-column text-overflow-ellipsis">
                        <p class="text-overflow-ellipsis mb-2"
                            [tooltip]="userInfo.fullName + ' (' + userInfo.userVerifiedMessage + ')'"
                            placement="top" container="body">
                            <span class="font-bold">{{userInfo.fullName}}</span>
                            <span class="ml-2 font-normal">
                                <span *ngIf="!userInfo.isUserVerified">(UnVerified)</span>
                                <sup *ngIf="userInfo.forwardRecipient">
                                    <span class="pointer" style="font-size: 20px;"
                                        [title]="userInfo.forwardFromUser ? 'Forwarded to ' + userInfo.forwardFromUser : 'Forwarded to me'">
                                        <i class="fa fa-share" aria-hidden="true"></i>
                                    </span>
                                </sup>
                                <sup *ngIf="userInfo.forwardToId !== null">
                                    <span class="pointer" style="font-size: 20px;"
                                        [title]="userInfo.forwardToUser ? 'Forwarded to ' + userInfo.forwardToUser : 'Forwarded to me'">
                                        <i class="fa fa-share" aria-hidden="true"></i>
                                    </span>
                                </sup>
                            </span>
                        </p>
                        <p class="mb-0" style="font-size: 13px;">
                            <span class="font-bold">Belongs to:</span>
                            <span class="ml-2">{{userInfo.belongsTo ? userInfo.belongsTo : 'NA'}}</span>
                        </p>
                    </div>
                </div>

                <!-- Role Column -->
                <div class="opacity-transition-500"
                    [ngClass]="{'col-xs-4 py-4': !showUserScope, 'col-xs-2 pt-4 pb-3': showUserScope}">
                    <div class="col-xs-12 px-0" [ngClass]="{'mb-2 pb-1': !showUserScope, 'mb-2 pb-2': showUserScope}">
                        <div class="px-0 d-flex justify-content-start align-items-center" style="padding-top: 2px;">
                            <h2 class="p-0 m-0 font-bold text-overflow-ellipsis" style="font-size: 14px;"
                                [tooltip]="userInfo.roleDescription" placement="top" container="body">
                                {{userInfo.roleDescription}}
                            </h2>
                        </div>
                    </div>
                    <div class="col-xs-12 px-0 d-flex flex-row flex-nowrap justify-content-start"
                        style="font-size: 13px;">
                        <div class="d-flex justify-content-start align-items-center pr-3">
                            <div class="text-nowrap">
                                <span class="font-bold mr-1" tooltip="Assigned Requisitions"
                                    placement="top" container="body">
                                    # Req:
                                </span>
                                <span>{{userInfo.assignedRequisitionsCount}}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center opacity-transition-300 user-row-view-card-requisition pl-3"
                            [hidden]="!isUserScope">
                            <div class="d-flex flex-nowrap justify-content-end align-items-center">
                                <div class="d-flex flex-row flex-nowrap">
                                    <span class="d-block font-bold mr-1" tooltip="Assigned Candidates Count"
                                        placement="top" container="body">
                                        <i class="fa fa-users" aria-hidden="true"></i>
                                    </span>
                                    <span class="d-block">{{userInfo.assignedCandidatesCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- User Scope Column -->
                <div class="col-xs-6 px-0"
                    [ngClass]="{'pt-4 pb-3': showUserScope, 'py-4': !showUserScope}"
                    *ngIf="showUserScope">
                    <div class="col-xs-12 user-scope-panel opacity-transition-300 px-0" [hidden]="!isUserScope">
                        <h2 class="p-0 m-0 pl-3 mb-4 font-bold text-muted" style="font-size: 16px;">User Scope</h2>
                        <div class="d-flex flex-column">
                            <div class="px-3 d-flex mb-1">
                                <div class="mb-2 mr-3">
                                    <span *ngIf="companyType === 'Staffing'">
                                        <span class="mr-2">Client:</span>
                                        <span *ngIf="userInfo.userEntityScope && userInfo.userEntityScope.allclientOrBU"
                                            class="label label-primary scope-badge">All</span>
                                        <span *ngIf="!(userInfo.userEntityScope && userInfo.userEntityScope.allclientOrBU)"
                                            class="label label-primary scope-badge">List</span>
                                    </span>
                                    <span *ngIf="companyType === 'Corporation'">
                                        <span class="mr-2">BU:</span>
                                        <span *ngIf="userInfo.userEntityScope && userInfo.userEntityScope.withBuAndNoRES"
                                            class="label label-primary scope-badge">All</span>
                                        <span *ngIf="!(userInfo.userEntityScope && userInfo.userEntityScope.withBuAndNoRES) && (userInfo.userEntityScope && userInfo.userEntityScope.allclientOrBU)"
                                            class="label label-primary scope-badge">All</span>
                                        <span *ngIf="!(userInfo.userEntityScope && userInfo.userEntityScope.withBuAndNoRES) && !(userInfo.userEntityScope && userInfo.userEntityScope.allclientOrBU)"
                                            class="label label-primary scope-badge">List</span>
                                    </span>
                                </div>
                                <div *ngIf="companyType === 'Staffing'">
                                    <span class="mr-2">Client's BU:</span>
                                    <span *ngIf="userInfo.userEntityScope && userInfo.userEntityScope.allBusOfClient"
                                        class="label label-primary scope-badge">All</span>
                                    <span *ngIf="!(userInfo.userEntityScope && userInfo.userEntityScope.allBusOfClient)"
                                        class="label label-primary scope-badge">List</span>
                                </div>
                            </div>
                            <div>
                                <div class="col-xs-12 px-0 pl-3 d-flex flex-row">
                                    <h2 class="p-0 m-0 font-bold my-2 mr-2" style="font-size: 14px;">
                                        <span *ngIf="companyType === 'Corporation'">BUs:</span>
                                        <span *ngIf="companyType === 'Staffing'">Clients:</span>
                                    </h2>
                                    <div class="d-flex flex-row flex-wrap" *ngIf="clientOrBuList.length > 0">
                                        <div class="px-0 mb-2" *ngFor="let client of clientOrBuList; trackBy: trackByIndex">
                                            <span class="label label-primary scope-badge mr-2 mb-2"
                                                style="font-size: 12px;">
                                                {{client.companyName}}
                                            </span>
                                        </div>
                                    </div>
                                    <div *ngIf="clientOrBuList.length === 0" class="mt-1">
                                        <span *ngIf="companyType === 'Staffing'">No Clients</span>
                                        <span *ngIf="companyType === 'Corporation'">No Bus</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Actions Column -->
                <div class="px-0 d-flex justify-content-end" style="font-size: 13px;"
                    [ngClass]="{'col-xs-2': !showUserScope, 'col-xs-1': showUserScope}">
                    <div class="col-xs-12 px-0 profile-box-menu d-flex justify-content-end" style="text-align: end;">
                        <!-- Activity Monitor -->
                        <div class="profile-box-notification"
                            [ngClass]="{'pt-4 pb-3': showUserScope, 'py-4': !showUserScope}">
                            <div [id]="userInfo.userId + '-activity-dropdown'"
                                class="dropdown pull-right candidate-job-card-notification-icon btn-group">
                                <a class="btn dropdown-toggle pt-0" style="font-size: 16px;"
                                    [id]="'activity-list-' + userInfo.userId"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    title="Activity Monitor"
                                    (click)="showRecentActivities()">
                                    <i class="fa fa-list text-muted"></i>
                                </a>
                                <ul [id]="userInfo.userId + '-activity-dropdown-menu'"
                                    class="dropdown-menu candidate-job-match-activity-list position-absolute"
                                    style="z-index: 9999"
                                    role="menu">
                                    <app-recent-activities
                                        *ngIf="showRecentActivitiesFlag"
                                        [activityMap]="activityMap"
                                        [recentActivitiesControls]="recentActivitiesControls"
                                        [isActivityClicked]="isActivityClicked"
                                        context="userCard"
                                        [userId]="userInfo.userId"
                                        (activitiesLoadedCallback)="cardMenuToggled(true, userInfo.userId + '-activity-dropdown-menu')"
                                        (showAllCallback)="showAllActivityModal()">
                                    </app-recent-activities>
                                </ul>
                            </div>
                        </div>

                        <!-- Actions Dropdown -->
                        <div [ngClass]="{'pt-4 pb-3': showUserScope, 'py-4': !showUserScope}"
                            class="candidate-card-actions-row-view profile-box-content pr-3 btn-group">
                            <span
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style="font-size: 16px; padding-top: 3px;"
                                class="fas fa-ellipsis-v dropdown-toggle cursor-pointer px-2"
                                title="Actions">
                            </span>
                            <ul class="dropdown-menu dropdown-menu-right menu-items p-0 py-3"
                                role="menu"
                                style="top: 45px; right: 15px;">
                                <li class="dropdown-option action" *ngIf="userInfo.canEdit"
                                    (click)="viewProfile(userInfo, 'edit')">
                                    Edit
                                </li>
                                <li class="divider" *ngIf="userInfo.canDelete"></li>
                                <li class="dropdown-option action" *ngIf="userInfo.canDelete"
                                    (click)="deleteSelectedUser(userInfo)">
                                    Delete
                                </li>
                                <li class="divider" *ngIf="userInfo.canViewNotificationPref"></li>
                                <li class="dropdown-option action" *ngIf="userInfo.canViewNotificationPref"
                                    (click)="$state.go('missioncontrol.notificationpreference', {userId: userInfo.userId}, {reload: true})">
                                    Notification Preferences
                                </li>
                                <li class="divider" *ngIf="userInfo.userState !== 'Active'"></li>
                                <li class="dropdown-option action"
                                    *ngIf="userInfo.userState === 'UnVerfied' || userInfo.userState === 'PasswordReset'"
                                    (click)="resendInvite(userInfo)" style="padding-bottom: 6px">
                                    Resend Invite
                                </li>
                                <li class="divider" *ngIf="notCurrentUser"></li>
                                <li class="dropdown-option action" *ngIf="notCurrentUser"
                                    (click)="makeEmployee(userInfo)"
                                    [ngClass]="{'disable-element': companyState === 'SoftHold'}">
                                    Make Employee
                                </li>
                            </ul>
                        </div>

                        <!-- Expand/Collapse User Scope -->
                        <div *ngIf="!showUserScope"
                            class="d-flex align-items-center user-card-expand-icon-right pl-3 pr-2"
                            tooltip="Show User Scope" placement="top" container="body"
                            (click)="showAndHideUserScope()">
                            <span><i class="fas fa-chevron-right"></i></span>
                        </div>
                        <div *ngIf="showUserScope"
                            class="d-flex align-items-center user-card-expand-icon-left pl-3 pr-2"
                            tooltip="Hide User Scope" placement="top" container="body"
                            (click)="showAndHideUserScope()">
                            <span class="fas fa-chevron-left"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Recursive children for row view -->
    <ul class="list-unstyled ml-5" *ngIf="userInfo.users && userInfo.users.length > 0"
        [ngClass]="{'hidden': userInfo.collapsed}">
        <li class="my-3" *ngFor="let childUser of userInfo.users; trackBy: trackByUserId">
            <div class="d-flex flex-nowrap align-items-center">
                <app-user-card
                    class="col-xs-12"
                    [userInfo]="childUser"
                    [managers]="managers"
                    [activityMap]="activityMap"
                    [isUserRowViewActive]="isUserRowViewActive"
                    (deleteUserCallback)="deleteUserCallback.emit()">
                </app-user-card>
            </div>
        </li>
    </ul>
</div>
